module.exports = __webpack_public_path__ + "media/images/element/home-cdad06a5752f2202c43ce0fc981facf0.svg";